module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAMCAYAAABbayygAAAAyElEQVQoU2P8//8/LwMDQy0Q2wBxNSMj434gjQEYgQpXAUVDoTIvgbQ8UPFPdJUghXeAgspIErZAhUewKTwKFLSCSoAUuAMVfsOmsBUoWAWVMAIqOo/LjRpAiatAzATES4AKY7EqBAkieeg/kOsJVLwTw2qoQjkgfQWIQUEF8rklED8DYkWgphsgNYwwnUBTo0BWQ8VAin8DsQwQrwTiaLhCqMk1QLoZixtzURRCFWcD6T4gZkPSUIShEKpYG0hXALEWEC8C4kkAxTpB4iL8e0oAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/phone.png
// module id = 5ng9
// module chunks = 15